import { ClinicProfileMap, TreatmentDays } from '../components/clinic/ClinicProfile';
import { ReserveBooking } from '../components/clinic/ReserveBooking';
import { Autocomplete } from '../components/Autocomplete';
import loadGoogleMapsApi from '../utils/MapManager';

function initAutocomplete() {
	window.mapQueue.push(() => {
		// eslint-disable-next-line no-unused-vars
		const header = new Autocomplete('[data-type="autocomplete"]', '[data-auto="results-wrapper"]');
	});
	loadGoogleMapsApi();
}

export function init() {
	console.info('Initializing `Search Profile`');
	ClinicProfileMap.init();
	ReserveBooking.init();
	initAutocomplete();
	TreatmentDays.init();
}
